import React from "react";
import "./TourPackages.css";

import manaliImg from "../assets/manali.png";
import spitiImg from "../assets/spiti.png";
import shimlaImg from "../assets/shimla.png";
import dharamshalaImg from "../assets/dharamshala.png";
import dharamshalaImg1 from "../assets/DharamShala-1.png";

export default function TourPackages() {
  return (
    <section className="bd-blog-area section-space pt-lg-5 pb-lg-4"   style={{
    display: "flex",
    justifyContent: "center",
  }}>
      <div className="container">

        {/* ---------------- FIRST ROW (YOUR ORIGINAL CARDS) ---------------- */}
        <div className="row no-wrap tour-card">

          {/* Shimla – Chandigarh Tour */}
          <div className="col-4 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/shimla-chandigarh-tour">
                  <img src={manaliImg} alt="Shimla Chandigarh Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list meta-inline">
                  <div className="blog-meta-item">
                    <i className="fa-solid fa-location-dot"></i>
                    <span>Shimla – Chandigarh</span>
                  </div>

                  <div className="blog-meta-item">
                    <i className="fa-solid fa-calendar-days"></i>
                    <span>06 Nights / 07 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/shimla-chandigarh-tour">Shimla Chandigarh Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/shimla-chandigarh-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

          {/* Spiti Tour */}
          <div className="col-lg-4 col-12 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/spiti-tour">
                  <img src={spitiImg} alt="Spiti Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list">
                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <span className="meta-text">Himachal Pradesh</span>
                  </div>

                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-calendar-days"></i>
                    </span>
                    <span className="meta-text">09 Nights / 10 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/spiti-tour">Spiti Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/spiti-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

          {/* Shimla – Manali Tour */}
          <div className="col-lg-4 col-12 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/manali-tour">
                  <img src={shimlaImg} alt="Shimla Manali Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list">
                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <span className="meta-text">Himachal Pradesh</span>
                  </div>

                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-calendar-days"></i>
                    </span>
                    <span className="meta-text">06 Nights / 07 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/manali-tour">Shimla Manali Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/manali-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

        </div>
        
        {/* ---------------- SECOND ROW ---------------- */}
        <div className="row no-wrap">

          {/* Shimla – Chandigarh Tour */}
          <div className="col-lg-4 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/shimla-chandigarh-tour">
                  <img src={dharamshalaImg1} alt="Shimla Chandigarh Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list meta-inline">
                  <div className="blog-meta-item">
                    <i className="fa-solid fa-location-dot"></i>
                    <span>Himachal Pradesh</span>
                  </div>

                  <div className="blog-meta-item">
                    <i className="fa-solid fa-calendar-days"></i>
                    <span>07 Nights / 08 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/Himachal-tour">Shimla/Manali/Dharamshala</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/Himachal-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

          {/* Spiti Tour */}
          <div className="col-lg-4 col-12 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/spiti-tour">
                  <img src={spitiImg} alt="Spiti Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list">
                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <span className="meta-text">Himachal Pradesh</span>
                  </div>

                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-calendar-days"></i>
                    </span>
                    <span className="meta-text">06 Nights / 07 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/spiti-tour">Spiti Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/spiti-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

          {/* Shimla – Manali Tour */}
          <div className="col-lg-4 col-12 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/manali-tour">
                  <img src={shimlaImg} alt="Shimla Manali Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list">
                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <span className="meta-text">Himachal Pradesh</span>
                  </div>

                  <div className="blog-meta-item">
                    <span className="meta-icon">
                      <i className="fa-solid fa-calendar-days"></i>
                    </span>
                    <span className="meta-text">06 Nights / 07 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/manali-tour">Shimla Manali Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/manali-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

        </div>

        {/* ---------------- THIRD ROW ---------------- */}
        <div className="row no-wrap tour-card" style={{marginTop:"20px"}}>

          {/* Pangi Valley Tour */}
          <div className="col-4 mb-4">
            <article className="bd-blog-wrapper blog-default blog-style-three">
              <div className="blog-thumb image-hover-effect">
                <a href="/pangi-valley-tour">
                  <img src={dharamshalaImg} alt="Pangi Valley Tour" />
                </a>
              </div>

              <div className="blog-content">
                <div className="blog-meta-list meta-inline">
                  <div className="blog-meta-item">
                    <i className="fa-solid fa-location-dot"></i>
                    <span>Pangi Valley</span>
                  </div>

                  <div className="blog-meta-item">
                    <i className="fa-solid fa-calendar-days"></i>
                    <span>07 Nights / 08 Days</span>
                  </div>
                </div>

                <h5 className="blog-title mb-30 underline">
                  <a href="/pangi-valley-tour">Pangi Valley Tour</a>
                </h5>

                <div className="blog-btn">
                  <a
                    href="/pangi-valley-tour"
                    className="bd-primary-btn btn-style has-arrow radius-60"
                  >
                    <span className="bd-primary-btn-text">View Details</span>
                    <span className="bd-primary-btn-circle"></span>
                    <span className="bd-primary-btn-arrow arrow-left">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </article>
          </div>

        </div>

      </div>
    </section>
  );
}